import { render, staticRenderFns } from "./CampanhaCadastroModal.vue?vue&type=template&id=09f85094&scoped=true"
import script from "./CampanhaCadastroModal.vue?vue&type=script&lang=js"
export * from "./CampanhaCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./CampanhaCadastroModal.vue?vue&type=style&index=0&id=09f85094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f85094",
  null
  
)

export default component.exports